// extracted by mini-css-extract-plugin
export var fadeInOut = "_41-3";
export var icon = "_41-4";
export var savedIndicator = "_41-2";
export var savingIndicator = "_41-0";
export var spin = "_41-1";